import React from "react";
import {BaseStaticFieldModalProps} from "../DynamicFormTypes.ts";
import Modal from "../../Modal.tsx";
import SamButton from "../../SamButton.tsx";
import {useFormMethods, useFormStatic} from "../DyanmicFormContext.tsx";
import {createLocalDate, formatDateNumeric} from "../../../utils/dateUtils.ts";
import {NotificationType, useNotification} from "../../../context/NotificationContext.tsx";

export const ConfirmEffectiveDateModal: React.FC<BaseStaticFieldModalProps> = React.memo(({
                                                                                   isOpen,
                                                                                   onClose
                                                                               }) => {

    const { formMethods } = useFormMethods()
    const { showNotification } = useNotification();
    const { formPermissions } = useFormStatic();


    const confirmEffectiveDate = () => {
        if (!formPermissions.canEdit) {
            console.warn("Edits or auto set values are not allowed");
            showNotification(NotificationType.INFO, "Edits or auto set values are not allowed");
            onClose();
            return;
        }
        formMethods.setValue("isEffectiveDateConfirmed", true);
        onClose();
    }

    const effectiveDate = createLocalDate(formMethods.getValues("effectiveDate"));
    const currentDate = createLocalDate(null);

    const isEffectiveDateValid = effectiveDate < currentDate;

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={"Confirm Effective Date?"}
        >
            <div className="flex flex-col space-y-1 mb-3">
                <label className="text-sm font-medium text-gray-700">Date To Confirm</label>
                <span className="text-base text-gray-900 bg-gray-100 px-3 py-1 rounded-md">
                    {formatDateNumeric(formMethods.getValues("effectiveDate"))}
                </span>
                {!isEffectiveDateValid && (
                    <p className="text-sm text-red-600 mt-1">
                        Effective date cannot be greater than current date.
                    </p>
                )}
            </div>

            <div className="flex justify-between">
                <SamButton
                    onClick={onClose}
                >
                    Cancel
                </SamButton>
                <SamButton
                    onClick={confirmEffectiveDate}
                    disabled={!isEffectiveDateValid}
                >
                    Confirm Date
                </SamButton>
            </div>
        </Modal>
    );

});